<div class="dictionary-display" (click)="onDictionaryClick()">
  <div class="result-icon" *ngIf="showIcon">
    <mat-icon>auto_stories</mat-icon>
  </div>
  <div class="result-content">
    <div class="result-header">
      <span class="dictionary-title" [innerHTML]="result.label"></span>
    </div>
    <div class="result-meta">
      <span *ngIf="result.info?.owner">by {{ result.info.owner }}</span>
      <span *ngIf="result.info?.words_count !== undefined && result.info?.pairs_count !== undefined">
        • {{ result.info.words_count }} words, {{ result.info.pairs_count }} pairs
      </span>
    </div>
  </div>
</div>
